import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import React from 'react';

export function showSelectedColor(mediaColor, primaryColor, code) {
    const filteredMediaColor = mediaColor ? mediaColor.split('&')[0] : null;

    if (filteredMediaColor && filteredMediaColor === code) {
        return true;
    } else if (filteredMediaColor === null){
        return primaryColor && (sessionStorage.getItem("exteriorColor") === code);
    }
}

export function buildColorTile(vehicle, colorHandler, secondaryColorHandler,handleColorBarHover, mediaColor, setHoverColor, primaryColor,id) {
    const { code, name, family, media } = vehicle;
    const colorTileStyle = { backgroundColor: media.primary };
    return (
        <React.Fragment>
            <div className={'color-shade'} id={code} key={`${name}-${family}`}>
                <div
                    className="color-swatch-image"
                    id={code}
                    onClick={ id === 0 ? colorHandler : secondaryColorHandler}
                    style={colorTileStyle}
                    data-vehicle-exteriorColor={name}
                    data-color-type="exterior"
                    onMouseEnter={handleColorBarHover}
                    onMouseLeave={() => setHoverColor('')}
                >
                    {showSelectedColor(mediaColor, primaryColor, code) && (
                        <div className={'checkmark'}>
                            <CheckCircleIcon fontSize={'medium'} />
                        </div>
                    )}
                </div>
            </div>
        </React.Fragment>
    );
}

export function buildInteriorColorTile(vehicle, colorHandler, handleColorBarHover, setHoverColor) {
    const { code, name, family, media } = vehicle;

    const colorTileStyle = { backgroundColor: media.primary };
    return (
        <React.Fragment>
            <div className={'color-shade'} id={code} key={`${name}-${family}`}>
                <div
                    className="color-swatch-image"
                    data-color-type="interior"
                    data-vehicle-interiorColor={name}
                    id={code}
                    onClick={colorHandler}
                    onMouseEnter={handleColorBarHover}
                    onMouseLeave={() => setHoverColor('')}
                    style={colorTileStyle}
                >
                </div>
            </div>
        </React.Fragment>
    );
}

export function showDefaultColor(mediaColor, primaryColor) {
    if (mediaColor === null){
        return primaryColor && primaryColor
            .filter((vehicle) => vehicle.code === sessionStorage.getItem("exteriorColor"))
            .map((vehicle) => vehicle.media.primary);
    }
    if (mediaColor !== 'NO_COLOR') {
        return primaryColor && primaryColor
            .filter((vehicle) => vehicle.code === mediaColor)
            .map((vehicle) => vehicle.media.primary);
    }
}

export function getColorName(primaryColor, mediaColor) {
    if (mediaColor === null){
        return primaryColor && primaryColor
            .filter((vehicle) => vehicle.code === sessionStorage.getItem("exteriorColor"))
            .map((vehicle) => vehicle.name);

    }
    if (mediaColor !== 'NO_COLOR') {
        return primaryColor && primaryColor
            .filter((code) => code.code === mediaColor)
            .map((code) => code.name);
    }
}

export function getCurrentExteriorColor(exterior, hoverColor, primaryColor, mediaColor,id) {
    if (id !==0){
        return exterior ? exterior : getColorName(primaryColor, mediaColor)
    }
    else {
        return hoverColor ? hoverColor : getColorName(primaryColor, mediaColor)
    }
}

export function getCurrentInteriorColor(interior, hoverColor) {
    return hoverColor !=='' ? hoverColor : interior;
}

